import {
  useCallback, useMemo, useRef, useState,
} from 'react';
import format from 'string-template';

import Coach from '../../../../Model/Coach';
import useComponentMounted from '../../../../hooks/useComponentMounted';
import useToast from '../../../hooks/useToast';
import { isActiveUnpausedClient } from '../../../utils/podCapacity';

import texts from '../texts';

const useActiveClientCounts = () => {
  const [counts, setCounts] = useState({});
  const requestedCoachIdsRef = useRef(new Set());
  const hasReportedFailureRef = useRef(false);
  const isComponentMountedRef = useComponentMounted();
  const { showToast } = useToast();

  const requestCount = useCallback(async (coachId) => {
    if (!coachId || requestedCoachIdsRef.current.has(coachId)) {
      return;
    }
    requestedCoachIdsRef.current.add(coachId);

    try {
      const clients = await Coach.getInPodClients(coachId);
      const count = clients.filter(isActiveUnpausedClient).length;

      if (isComponentMountedRef.current) {
        setCounts((currentCounts) => ({ ...currentCounts, [coachId]: count }));
      }
    } catch (error) {
      if (isComponentMountedRef.current) {
        setCounts((currentCounts) => ({ ...currentCounts, [coachId]: null }));

        if (!hasReportedFailureRef.current) {
          hasReportedFailureRef.current = true;
          showToast(format(texts.activeClientsLoadFailed, { error: error.message }), { error: true });
        }
      }
    }
  }, [isComponentMountedRef, showToast]);

  return useMemo(() => ({
    counts,
    requestCount,
  }), [counts, requestCount]);
};

export default useActiveClientCounts;
